package practicetest

import flashcards.FlashCard
import kotlinx.serialization.Serializable

@Serializable
data class SubjectResponse(val subjects: List<Subject>)

@Serializable
data class Subject(val name: String, val key: String)


@Serializable
data class TopicListResponse(val subject: String, val topics: List<Topic>)


@Serializable
data class Topic(val key: String, val name: String, val description: String)


@Serializable
data class MaterialsResponse(
    val subject: String,
    val topic: String,
    val flashCards: List<FlashCard>,
    val practiceTest: PracticeTest?
)


@Serializable
data class PracticeTestQuestion(
    val questionText: String,
    val correctAnswers: List<String>,
    val incorrectAnswers: List<String>
)


@Serializable
data class PracticeTest(val questions: List<PracticeTestQuestion>)